import { render, staticRenderFns } from "./vulReportStatusTable.vue?vue&type=template&id=f2eeb974&scoped=true"
import script from "./vulReportStatusTable.vue?vue&type=script&lang=js"
export * from "./vulReportStatusTable.vue?vue&type=script&lang=js"
import style0 from "./vulReportStatusTable.vue?vue&type=style&index=0&id=f2eeb974&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2eeb974",
  null
  
)

export default component.exports